import { render } from "./NestedPage.vue?vue&type=template&id=6d3dfd11"
import script from "./NestedPage.vue?vue&type=script&lang=js"
export * from "./NestedPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__